import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";

 export class DispatchNoteBus extends BaseBus
 { 
     constructor(busObj: BaseBus = null) {
         super(busObj);
         this.insertDt = DateFunctions.getDate(this.insertDt);
         this.updatedt = DateFunctions.getDate(this.updatedt);
//         this.updatedt = DateFunctions.getDateTimeWithUTCOffset(this.updatedt);

     }
     setBeforeSave() {
         this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
         this.updatedt = DateFunctions.getDateTimeWithUTCOffset(DateFunctions.getDateNow());
     }
     dispatchNotesId: any;
     dispatchId: any;
     dispatchNotesPersonId: any;
     visibleToCustomer: boolean;
     dispatchNotes1: string;
     insertUserId: any;
     insertDt: Date;
     updateUserId: any;
     updatedt: Date;
     isWarning: boolean;
     highlight: boolean;
     hideLogBook: boolean;
 }
